export default function (error) {
  Sentry.captureException(error);
  console.error(error);
  location.reload()
}